export const ROLE_ASSIGNMENT_REMARKS_MAX_LENGTH = 2500;
